













import Vue from 'vue';
import Component from 'vue-class-component';
import { Header, Footer, Sider } from './components/Layout/index';
import { vieImg } from "@/utils/viewImg";

@Component({
    components: {
        Header,
        Footer,
        Sider,
    }
})
export default class App extends Vue {
    created(): void {
        this.tryLogin();
    }
    mounted (): void {
        vieImg();
    }
    async tryLogin () {
        const accesstoken = window.localStorage.getItem('accesstoken');
        await this.$store.dispatch('accesstoken', {accesstoken});
        let accessInfo = this.$store.state.app.accessInfo;
        if (accessInfo.success) {
            this.$store.dispatch('changeAccesstoken', {accesstoken});
            await this.$store.dispatch('getMessageCount', {accesstoken});
            await this.$store.dispatch('getMessage', {
                accesstoken,
                mdrender: true
            });
        }
    }
};
